import { Image } from 'react-bootstrap';
import { isEmptyValue } from './emptyValue';

const displayValue = (value) => {
    if (typeof value === 'boolean') return value ? 'Yes' : 'No';
    return value;
};

// icon + label + value row for the compact mobile company-detail tree.
// Renders nothing when value is empty (see emptyValue.js) so optional data
// disappears cleanly instead of showing placeholder text.
const InfoRow = ({ icon, iconAlt = '', label, value, href, external = true, className = '' }) => {
    if (isEmptyValue(value)) return null;

    const content = href ? (
        <a
            href={href}
            target={external ? '_blank' : undefined}
            rel={external ? 'noopener noreferrer' : undefined}
        >
            {displayValue(value)}
        </a>
    ) : (
        displayValue(value)
    );

    return (
        <div className={`icon-text ${className}`.trim()}>
            {icon && (
                <span className="icon" aria-hidden="true">
                    <Image src={icon} alt={iconAlt} />
                </span>
            )}
            <span className="text">
                {label}
                <br />
                <strong>{content}</strong>
            </span>
        </div>
    );
};

export default InfoRow;
